import React, {
    useState,
    forwardRef,
    useEffect,
    useMemo,
    useLayoutEffect,
    useRef,
} from "react";
import Carousel from "react-bootstrap/Carousel";
import ppvLock from "../../images/silver-app.png";
import SingleCheck from "../../images/single-check.png";
import DoubleCheck from "../../images/double-check.png";
import Avatar from "../../common/Avatar";
import {
    CARD_ERRORS,
    MESSAGE_TYPE,
    s3Link,
    TRANSACTION_TYPE,
} from "../../utils/constants";
import moment from "moment";
import { connect, useDispatch } from "react-redux";
import currency from "currency.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OnImagesLoaded from "react-on-images-loaded";
import {
    updateTriggerScrollBottomR,
    updateShowImageModalR,
    updateImageModalSrcR,
    updateShowBundleModalR,
    updateBundleModalSrcR,
    updateBundleIndexR,
    updateMsgOptionOpenR,
    updateshowVideoModalR,
    updateShowVerificationR,
    setContainerClass,
    updateCcVerification,
    updateMsgStatsR,
    setAlert,
    setCreditCardForm,
} from "../../../redux/actions";
import PAlert from "../../common/PAlert";
import {
    bannedWords,
    checkAspectRatio,
    splitTime,
} from "../../../components/utils/helper";
import Duration from "../../../components/common/Duration";
import { Spinner } from "react-bootstrap";
import Thumbprint from "../../common/Thumbprint";
import { Menu, MenuItem, useMediaQuery } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CircularProgress from "@mui/material/CircularProgress";
import videoJS from "../../common/VideoJS";
import {
    setVideoPlayerId,
    setVideoPlayerIsPlaying,
} from "../../../redux/actions/videoPlayer";
import PriceText from "../../common/PriceText";
import CountDownTimer from "../../common/CountDownTimer";
import PaymentOptions from "../../common/PaymentOptions";

const settings = {
    controls: true,
    indicators: false,
    fade: false,
    slide: false,
    // touch: false,
};

const MessageItem = forwardRef(
    (
        {
            msgStats,
            user,
            message,
            updateTriggerScrollBottom,
            triggerScrollBottom,
            updateShowImageModal,
            updateImageModalSrc,
            updateShowBundleModal,
            updateBundleModalSrc,
            updateBundleIndex,
            msgOptionOpen,
            updateMsgOptionOpen,
            updateshowVideoModal,
            updateShowVerification,
            active,
            setShowVerificationError,
            setProcessPPV,
            processPPV,
            setContainerClass,
            fetchMessages,
            syncRemove,
            setMessages,
            messages,
            updateCcVerification,
            updateMsgStats,
            setAlert,
            isOnModal = false,
            source = "messenger",
            setPaidItem = () => ({}),
            readCollection,
            setCreditCardForm,
            convIndex,
            convList,
            mutedByOther,
        },
        ref
    ) => {
        const carouselRef = useRef();
        const dispatch = useDispatch();
        const isMobile = useMediaQuery("(max-width: 899px)");

        const [item, setItem] = useState(message);
        const [confirmPay, setConfirmPay] = useState(false);
        const [closeToTop, setCloseToTop] = useState(false);
        const [processingPay, setProcessingPay] = useState(false);
        const [activeMsg, setActiveMsg] = useState("");
        const [statsLoading, setStatsLoading] = useState(false);
        const [paidPpvs, setPaidPpvs] = useState([]);
        const [ppvFees, setPpvFees] = useState({});
        const [removeMsgs, setRemoveMsgs] = useState([]);
        const [hasPaid, setHasPaid] = useState([]);
        const [msgOptionOpenH, setMsgOptionOpenH] = useState("");
        const [busy, setBusy] = useState(false);
        const [msgId, setMsgId] = useState("");
        const [amount, setAmount] = useState(0);
        const [userDetails, setUserDetails] = useState([]);
        const [showOptions, setShowOptions] = useState(false);
        const [isRemoving, setIsRemoving] = useState(false);
        const [activeUsername, setActiveUsername] = useState("");
        const [isDiscounted, setIsDiscounted] = useState(false);
        const [isValidDate, setIsValidDate] = useState(true);
        const [showPaymentOptions, setShowPaymentOptions] = useState(false);
        const [isGettingMessage, setIsGettingMessage] = useState(false);

        useEffect(() => {
            if (
                convIndex >= 0 &&
                convList &&
                convList.length > 0 &&
                convList[convIndex]
            ) {
                const uname = convList[convIndex].other_user;
                setActiveUsername(uname);
            }
        }, [convIndex]);

        useEffect(() => {
            let mounted = true;
            if (processPPV) {
                ppvProcessPayment(amount, msgId);
            }
            return () => {
                return (mounted = false);
            };
        }, [processPPV]);

        useEffect(() => {
            setUserDetails(localStorage.getItem("loggedin_user"));

            $(".su-free-preview__media > div").css({
                "max-height": $(".messenger-main").height() - 40,
            });
        }, []);

        useEffect(() => {
            setItem(message);

            const validDate = moment(message.expire_at).isValid();

            if (
                parseFloat(message.promo_price) > 0 &&
                message.expire_at &&
                !!validDate
            ) {
                const expiry = moment.utc(message.expire_at).local();
                if (moment().isSameOrAfter(expiry, "seconds")) {
                    setIsDiscounted(false);
                } else {
                    setIsDiscounted(true);
                }
            }

            setIsValidDate(!!validDate);
        }, [message]);

        const openModalImage = (media) => {
            const img = media.large_path ? media.large_path : media.file_path;
            const aspectRatio = checkAspectRatio(media.aspect_ratio);
            setContainerClass(aspectRatio);
            updateShowImageModal(true);
            updateImageModalSrc(img);
        };

        const openModalVideo = (
            vid,
            msg_type = 0,
            msg_id = 0,
            sender_id,
            media = {}
        ) => {
            const aspectRatio = checkAspectRatio(media.aspect_ratio);
            setContainerClass(aspectRatio);
            updateshowVideoModal(true);
            updateImageModalSrc(vid);
        };

        const openModalBundle = (bundle_src, index) => {
            let aspectRatios = bundle_src.map((media) =>
                checkAspectRatio(media.aspect_ratio)
            );

            if (aspectRatios.includes(" l_3_4")) {
                setContainerClass(" l_3_4");
            }

            if (aspectRatios.includes(" l_9_16")) {
                setContainerClass(" l_9_16");
            }

            if (aspectRatios.includes(" l_9_22")) {
                setContainerClass(" l_9_22");
            }

            if (aspectRatios.includes(" p_1_1")) {
                setContainerClass(" p_1_1");
            }

            if (aspectRatios.includes(" p_3_4")) {
                setContainerClass(" p_3_4");
            }

            if (aspectRatios.includes(" p_9_16")) {
                setContainerClass(" p_9_16");
            }

            if (aspectRatios.includes(" p_9_22")) {
                setContainerClass(" p_9_22");
            }

            if (aspectRatios.length <= 0) {
                setContainerClass(" p_4_4");
            }

            updateShowBundleModal(true);
            updateBundleIndex(index);
            updateBundleModalSrc(bundle_src);
        };

        const payPPV = async (amount, m) => {
            let msg_id = m.id;
            setBusy(true);
            setAmount(amount);
            setMsgId(msg_id);
            setProcessingPay(true);
            // setProcessPPV(false)
            await axios
                .get("/api/transactions/check", {
                    params: {
                        message_id: msg_id,
                    },
                })
                .then((response) => {
                    if (response.data.check) {
                        ppvProcessPayment(amount, msg_id);
                    } else {
                        setCreditCardForm({
                            show: true,
                            prefilled: true,
                            closeOnly: true,
                            intent: "ppv payment",
                            username: activeUsername,
                        });
                        setProcessingPay(false);
                    }
                })
                .catch((error) => {
                    console.error({ error });
                    setBusy(false);
                    setProcessingPay(false);
                    setAlert({
                        show: true,
                        type: "error",
                        body: "Unable to process PPV payment",
                    });
                });
        };

        const ppvProcessPayment = async (amount = null, msg_id = null) => {
            if (amount && msg_id) {
                setBusy(true);
                setProcessPPV(false);
                await axios
                    .post("/api/transactions/ppv-pay", {
                        amount: amount,
                        user_id: active,
                        msg_id: msg_id,
                    })
                    .then((response) => {
                        if (!response.data.success && response.data.url) {
                            window.location = response.data.url;
                            return;
                        }

                        if (response.data.success) {
                            setPaidPpvs([...paidPpvs, response.data.data.id]);
                            setProcessingPay(false);
                            setItem(response.data.data);

                            if (source === "messenger") {
                                const tmp = [...messages];
                                const index = messages.findIndex(
                                    (m) => m.id == response.data.data.id
                                );
                                if (index >= 0) {
                                    tmp[index] = response.data.data;
                                    setMessages([...tmp]);
                                }
                            }

                            // used by parent component to update images
                            setPaidItem(response.data.data);
                        } else {
                            if (response.data.msg_error == "") {
                                setAlertBody(
                                    "Please ensure you have sufficient funds and then try again."
                                );
                                setShowAlert(true);
                            } else {
                                setAlertBody(response.data.msg_error);
                                setShowAlert(true);
                            }
                        }
                        setBusy(false);
                        setProcessingPay(false);
                    })
                    .catch((error) => {
                        console.error({ error });
                        setBusy(false);
                        setProcessingPay(false);

                        if (error.response && error.response.status === 402) {
                            if (
                                error.response.data.error ===
                                CARD_ERRORS.NO_CARD
                            ) {
                                setCreditCardForm({
                                    show: true,
                                    prefilled: true,
                                    closeOnly: true,
                                    intent: "ppv payment",
                                    username: activeUsername,
                                });
                                return;
                            } else if (
                                error.response.data.error ===
                                CARD_ERRORS.NEEDS_VALIDATION
                            ) {
                                updateCcVerification({
                                    showVerify: true,
                                });
                                return;
                            } else {
                                setCreditCardForm({
                                    show: true,
                                    prefilled: true,
                                    closeOnly: true,
                                    intent: "ppv payment",
                                    username: activeUsername,
                                });
                                setAlert({
                                    show: true,
                                    type: "error",
                                    body:
                                        error.response.data.message ||
                                        "Failed to process PPV payment",
                                    size: "md",
                                });

                                return;
                            }
                        }

                        if (error.response && error.response.status === 400) {
                            updateShowVerification(true);
                            return;
                        }

                        if (error.response && error.response.status === 422) {
                            const responseData = error.response.data;
                            const firstErrorKey = Object.keys(
                                responseData.errors
                            );

                            setAlert({
                                show: true,
                                type: "error",
                                body:
                                    responseData.errors[firstErrorKey][0] ||
                                    "Your card has been declined by your bank, please contact your bank or use another card.",
                                size: "md",
                            });
                            return;
                        }

                        if (error.response && error.response.status === 409) {
                            fetchMessages("page");
                            setAlert({
                                show: true,
                                type: "error",
                                body:
                                    error.response.data.error ||
                                    "PPV has already been purchased. Please reload the page",
                            });

                            setTimeout(() => {
                                $(".messenger-main").animate(
                                    {
                                        scrollTop: $(
                                            `#um-message-item-${msg_id}`
                                        )
                                            .parent("div")
                                            .offset().top,
                                    },
                                    800
                                );
                            }, 1000);

                            return;
                        }

                        if (error.response && error.response.status == 402) {
                            setCreditCardForm({
                                show: true,
                                prefilled: true,
                                closeOnly: true,
                                intent: "ppv payment",
                                username: activeUsername,
                            });
                            setAlert({
                                show: true,
                                type: "error",
                                body: error.response.data.error,
                            });
                            return;
                        }

                        if (error.response && error.response.status == 404) {
                            setAlert({
                                show: true,
                                type: "error",
                                body: "PPV is no longer available",
                            });
                            return;
                        }

                        if (
                            error.response &&
                            error.response.status > 400 &&
                            error.response.status < 500
                        ) {
                            setCreditCardForm({
                                show: true,
                                prefilled: true,
                                closeOnly: true,
                                intent: "ppv payment",
                                username: activeUsername,
                            });
                        }

                        let defaultMessage =
                            'There is an error processing the payment, please contact support <a href="https://priva.uvdesk.com/en/" target="_blank">here</a>.';
                        if (error.response && error.response.data.message) {
                            defaultMessage = error.response.data.message;
                        }
                        setAlert({
                            show: true,
                            type: "error",
                            body: error.response.data.message || defaultMessage,
                            size: "md",
                        });
                    });
            } else {
                setProcessingPay(false);
            }
        };

        const [showAlert, setShowAlert] = useState(false);
        const [alertTitle, setAlertTitle] = useState(false);
        const [alertBody, setAlertBody] = useState("");
        const handleUnlockMedia = async (sender_id, price, message_id) => {
            await axios
                .post("/api/check/subscription", {
                    user: sender_id,
                    amount: price,
                })
                .then((response) => {
                    setConfirmPay(message_id);

                    axios
                        .get(`/api/transactions/fees_ppv`, {
                            params: {
                                pu: active,
                                ppv_price: price,
                            },
                        })
                        .then((response) => {
                            setPpvFees(response.data);
                        });
                })
                .catch((error) => {
                    console.log({ error });
                    if (error.response.status == 403) {
                        setAlertTitle("Subscription Check");
                        setAlertBody(
                            "You must be subscribed to purchase a PPV"
                        );
                        setShowAlert(true);
                    } else {
                        setAlertBody(
                            'There was an error in checking your subscription. Please contact support <a href="https://priva.uvdesk.com/en/" target="_blank">here</a>.'
                        );
                        setShowAlert(true);
                    }
                });
        };

        const openOptions = () => {
            if (item.broadcast_id <= 0 || item.price <= 0) {
                return;
            }
            const msg_id = item.id;
            setStatsLoading(true);
            const formData = new FormData();
            formData.append("msg_id", msg_id);
            setShowOptions(true);
            axios({
                method: "post",
                url: "/api/msg-stats",
                data: formData,
            })
                .then((data) => {
                    setMsgOptionOpenH(msg_id);
                    setActiveMsg(msg_id);
                    setStatsLoading(false);
                    updateMsgStats(data.data.msg_stats);
                })
                .catch((error) => {
                    console.error(error);
                });
        };

        const changeScrollBottomMsg = () => {};

        const openFreePreview = (media) => {
            if (media.type.toLowerCase() == "image") {
                openModalImage(item.medias[0]);
            } else {
                openModalVideo(item.medias[0].file_path);
            }
        };

        const Media = React.memo(function Media({
            media,
            sender_id,
            msg_type,
            msg_id,
            isStory = false,
        }) {
            const user = JSON.parse(localStorage.getItem("user"));
            if (media.type === "video" || media.type === "VIDEO") {
                let isPrev = false;
                let videoSrc = `${s3Link}/${media.file_path}`;
                let thumbSrc = `${s3Link}/${media.thumb_path}`;

                if (msg_type === MESSAGE_TYPE.STORY) {
                    videoSrc = `${s3Link}/${media.file_path}`;
                    thumbSrc = `${s3Link}/${media.thumb_path}`;
                }

                if (sender_id !== user) {
                    if (paidPpvs.find((element) => element == msg_id)) {
                        thumbSrc = `${s3Link}/${media.thumb_path}`;
                    } else if (msg_type == 1) {
                        //unpaid has msg_type = 1 and status = 0
                        thumbSrc = `${s3Link}/${media.blurred_path}`;

                        let m_created_at = new Date(media.created_at);
                        let until_date = new Date("2021-12-13 07:09:56");

                        if (m_created_at < until_date) {
                            isPrev = true;
                            thumbSrc = `${s3Link}/${media.thumb_path}`;
                        }
                    } else {
                        thumbSrc = `${s3Link}/${media.thumb_path}`;
                    }
                }

                return (
                    <div
                        className="vid_thumb_cont vid_thumb_cont_m"
                        onClick={() =>
                            openModalVideo(
                                media.file_path,
                                msg_type,
                                msg_id,
                                sender_id,
                                media
                            )
                        }
                    >
                        {user.id !== media.pu_id &&
                            media.file_path !== null && (
                                <div
                                    className={
                                        "message-item-thumbprint-preview-container"
                                    }
                                >
                                    <Thumbprint />
                                </div>
                            )}
                        <div className={"vid-thumb-single"}>
                            <FontAwesomeIcon icon={["fas", "play-circle"]} />
                            <img
                                src={thumbSrc}
                                className={
                                    "img-fluid " +
                                    (isPrev ? " blur-thumb-fix " : "")
                                }
                                alt="Your browser wasn't able to download the media file, please refresh browser or check your internet is not having dropouts."
                                threshold={1000}
                                onContextMenu={(e) => e.preventDefault()}
                                nosave="true"
                            />
                            {(paidPpvs.find((element) => element == msg_id) ||
                                msg_type != 1) && (
                                <Duration duration={media.vid_duration} />
                            )}
                        </div>
                    </div>
                );
            }

            if (media.type == "image" || media.type == "IMAGE") {
                let imgSrc = "";
                let effect = "";

                if (sender_id != localStorage.getItem("loggedin_user")) {
                    if (paidPpvs.find((element) => element == msg_id)) {
                        imgSrc = `${s3Link}/${media.thumb_path}`;
                    } else if (msg_type == 1) {
                        //unpaid has msg_type = 1 and status = 0
                        imgSrc = `${s3Link}/${media.blurred_path}`;
                    } else {
                        imgSrc = `${s3Link}/${media.thumb_path}`;
                    }
                }

                if (sender_id == localStorage.getItem("loggedin_user")) {
                    if (media.thumb_path)
                        imgSrc = `${s3Link}/${media.thumb_path}`;
                    else imgSrc = `${s3Link}/${media.file_path}`;
                    effect = "blur";
                }

                if (msg_type == MESSAGE_TYPE.STORY) {
                    if (media.thumb_path)
                        imgSrc = `${s3Link}/${media.thumb_path}`;
                    else imgSrc = `${s3Link}/${media.file_path}`;
                }

                return (
                    <OnImagesLoaded onLoaded={changeScrollBottomMsg}>
                        {user.id !== media.pu_id &&
                            media.file_path !== null && (
                                <div
                                    className={
                                        "message-item-thumbprint-preview-container"
                                    }
                                >
                                    <Thumbprint />
                                </div>
                            )}
                        <img
                            src={imgSrc}
                            effect={effect}
                            className="img-fluid"
                            alt="Your browser wasn't able to download the media file, please refresh browser or check your internet is not having dropouts."
                            threshold={1000}
                            onContextMenu={(e) => e.preventDefault()}
                            nosave="true"
                        />
                    </OnImagesLoaded>
                );
            }

            return "";
        });

        const padTo2Digits = (num) => {
            return num.toString().padStart(2, "0");
        };

        const renderDuration = (totalSeconds) => {
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            let label = "";

            if (minutes >= 1) {
                label = `${padTo2Digits(minutes)}m`;
            }

            if (seconds > 0) {
                label += ` ${padTo2Digits(seconds)}s`;
            }

            return label;
        };

        const renderPaymentButton = (item, isProcessing, isDiscounted) => {
            return !isProcessing ? (
                <div
                    className={`ppv-unlock-btn`}
                    // onClick={() => payPPV(item.price, item)}
                    onClick={() => {
                        setShowPaymentOptions(true);
                    }}
                >
                    PAY{" "}
                    <PriceText
                        price={item.price}
                        discountedPrice={item.promo_price}
                        isDiscounted={isDiscounted}
                    />
                </div>
            ) : (
                <div className={`ppv-unlock-btn`} style={{ cursor: "wait" }}>
                    PROCESSING...
                </div>
            );
        };

        const PrevIcon = React.memo(() => {
            return (
                <span
                    aria-hidden="true"
                    className="carousel-control-prev-icon"
                />
            );
        });

        const NextIcon = React.memo(() => {
            return (
                <span
                    aria-hidden="true"
                    className="carousel-control-next-icon"
                />
            );
        });

        const [showConfirm, setShowConfirm] = useState(false);
        const [confirmModalBody, setConfirmModalBody] = useState("");
        const [messageId, setMessageId] = useState("");
        const [removeAll, setRemoveAll] = useState("");
        const handleConfirm = (event, type = "") => {
            event.preventDefault();
            setMessageId(item.id);
            setRemoveAll(type);
            const confirmBody = "Are you sure you want to remove?";
            setConfirmModalBody(confirmBody);
            setShowConfirm(true);
        };

        const open = Boolean(anchorEl);
        const [anchorEl, setAnchorEl] = useState(null);
        const [activeItem, setActiveItem] = useState(null);
        const handleClose = () => {
            setAnchorEl(null);
            setActiveItem(null);
        };

        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
            setActiveItem(item.id);
            openOptions();
        };

        const removeMessage = () => {
            setIsRemoving(true);

            axios
                .delete("/api/remove-message", {
                    data: {
                        msg_id: item.id,
                        remove_all: removeAll,
                    },
                })
                .then((response) => {
                    setShowConfirm(false);
                    setIsRemoving(false);
                    setAnchorEl(null);
                    if (response.data.num_purchased <= 0) {
                        syncRemove(messageId);
                    }

                    setConfirmModalBody("");
                    setMessageId("");
                    updateMsgStats({
                        sent_num: "",
                        read_num: "",
                        paid_num: "",
                        total_sales: "",
                        total_earnings: "",
                        is_bundle: "no",
                    });

                    // get conversation list
                    window.dispatchEvent(new Event("chatmessage/fetchConvs"));
                })
                .catch((error) => {
                    console.error(error);
                    setIsRemoving(false);
                });
        };

        const [isMutedMessage, setIsMutedMessage] = useState(false);

        useEffect(() => {
            setIsMutedMessage(mutedByOther);
        }, [mutedByOther]);

        const handleEndTime = () => {
            setIsDiscounted(false);
        };

        const handleOnSuccessPayment = async () => {
            setIsGettingMessage(true);
            await axios
                .get(`/api/messages/${item.id}`)
                .then((response) => {
                    setIsGettingMessage(false);
                    setItem(response.data);
                    setPaidPpvs([...paidPpvs, response.data.id]);
                })
                .catch((error) => {
                    console.error({ error });
                    setIsGettingMessage(false);
                });
        };

        return (
            <div
                className={
                    "message-item-out " +
                    (item && item.medias && item.medias.length == 0
                        ? " message-item-out-textonly "
                        : " message-item-out-hasfile ") +
                    (removeMsgs.includes(item.id) ? " out-msg-hide" : "")
                }
            >
                <div
                    key={item.id}
                    id={`um-message-item-${item.id}`}
                    className={`chatmessage um-message-item right_m reply-bx ${
                        item.sender_id == localStorage.getItem("loggedin_user")
                            ? "sender send-msg"
                            : "recive-msg"
                    } ${
                        item.price > 0 &&
                        item.sender_id !=
                            localStorage.getItem("loggedin_user") &&
                        item.msg_type == 1 &&
                        item.medias.length > 1 &&
                        !paidPpvs.includes(item.id)
                            ? " bundle-paid-item "
                            : ""
                    } ${closeToTop ? " close_to_top" : ""}${
                        isOnModal ? " message__on-modal" : ""
                    }`}
                >
                    {!isOnModal && (
                        <div className="user-img">
                            <Avatar
                                size="40"
                                pu={{
                                    id: item.sender_id,
                                    profile_pic: item.other_user_pic,
                                }}
                                story={false}
                            />
                        </div>
                    )}
                    <div className="user-reply">
                        {!isOnModal && (
                            <div className="time-post">
                                {moment
                                    .utc(item.created_at)
                                    .local()
                                    .format("LLL")}
                            </div>
                        )}
                        {/* no free preview */}
                        <div className="option-message">
                            {item.sender_id === user.id && (
                                <div
                                    className="unsend"
                                    style={
                                        activeItem == item.id
                                            ? {
                                                  display: "flex",
                                                  alignItems: "center",
                                              }
                                            : {}
                                    }
                                >
                                    <div style={{ position: "relative" }}>
                                        <button
                                            className={`btn-default${
                                                !item.medias || item.medias <= 0
                                                    ? " txt-only"
                                                    : ""
                                            }`}
                                            type="button"
                                            id="basic-button"
                                            aria-controls={
                                                open ? "basic-menu" : undefined
                                            }
                                            aria-haspopup="true"
                                            aria-expanded={
                                                open ? "true" : undefined
                                            }
                                            onClick={handleClick}
                                        >
                                            <FontAwesomeIcon
                                                icon={["fas", "ellipsis-h"]}
                                            />
                                        </button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={!!anchorEl}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                "aria-labelledby":
                                                    "basic-button",
                                            }}
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "center",
                                            }}
                                            transformOrigin={{
                                                vertical: "top",
                                                horizontal: "center",
                                            }}
                                            sx={{
                                                style: {
                                                    transform:
                                                        "translateX(10px) translateY(50px)",
                                                },
                                                zIndex: 9999,
                                            }}
                                        >
                                            {!statsLoading &&
                                                msgStats.is_bundle != "no" &&
                                                item.price > 0 && (
                                                    <MenuItem
                                                        dense
                                                        divider
                                                        onClick={(e) =>
                                                            e.preventDefault()
                                                        }
                                                        sx={{
                                                            bgcolor:
                                                                "background.paper",
                                                            color: "text.secondary",
                                                            fontSize: 12,
                                                            display: "block",
                                                        }}
                                                    >
                                                        PPV statistics:
                                                        <br />
                                                        <span
                                                            style={{
                                                                marginLeft:
                                                                    "4px",
                                                                fontSize:
                                                                    "12px",
                                                                display:
                                                                    "block",
                                                            }}
                                                        >
                                                            <span className="sent_num">
                                                                {
                                                                    msgStats.sent_num
                                                                }
                                                            </span>{" "}
                                                            sent,
                                                            <span className="read_num">
                                                                {
                                                                    msgStats.read_num
                                                                }
                                                            </span>{" "}
                                                            read,
                                                            <span className="paid_num">
                                                                {
                                                                    msgStats.paid_num
                                                                }
                                                            </span>{" "}
                                                            paid
                                                            <br />
                                                            Total Sales:&nbsp;
                                                            <span className="total_sales">
                                                                $
                                                                {
                                                                    msgStats.total_sales
                                                                }
                                                            </span>
                                                            <br />
                                                            Total
                                                            Earnings:&nbsp;
                                                            <span className="total_earnings">
                                                                $
                                                                {
                                                                    msgStats.total_earnings
                                                                }
                                                            </span>
                                                        </span>
                                                    </MenuItem>
                                                )}

                                            {item.broadcast_id > 0 && (
                                                <MenuItem
                                                    dense
                                                    onClick={(e) =>
                                                        handleConfirm(
                                                            e,
                                                            "remove_all"
                                                        )
                                                    }
                                                    sx={{
                                                        fontSize: 12,
                                                        display: "block",
                                                    }}
                                                >
                                                    Remove for all subscribers{" "}
                                                    {item.price > 0 ? (
                                                        <small>
                                                            <br />
                                                            (Paid PPVs are not
                                                            removed)
                                                        </small>
                                                    ) : (
                                                        ""
                                                    )}
                                                </MenuItem>
                                            )}

                                            <MenuItem
                                                dense
                                                onClick={(e) =>
                                                    handleConfirm(e)
                                                }
                                                sx={{ fontSize: 12 }}
                                            >
                                                Remove Message
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                </div>
                            )}

                            <div className="user-message">
                                {
                                    item.medias &&
                                    ((!item.has_free_preview &&
                                        [
                                            MESSAGE_TYPE.UNPURCHASED,
                                            MESSAGE_TYPE.PURCHASED,
                                        ].includes(item.msg_type)) ||
                                        (item.has_free_preview &&
                                            item.msg_type ==
                                                MESSAGE_TYPE.PURCHASED) ||
                                        item.sender_id ==
                                            localStorage.getItem(
                                                "loggedin_user"
                                            ) ||
                                        item.price <= 0) ? (
                                        <div
                                            className={`user-cmnt ${
                                                item.medias.length > 0
                                                    ? "thumimg"
                                                    : ""
                                            } ${
                                                item.medias.length > 1
                                                    ? "thumimg-multi"
                                                    : ""
                                            } ${
                                                item.price > 0
                                                    ? "ppv-price-add"
                                                    : ""
                                            } ${
                                                item.medias.length <= 0
                                                    ? " msg-text-only"
                                                    : ""
                                            }`}
                                        >
                                            {item.medias.length > 0 &&
                                            item.message ? (
                                                <div
                                                    className={
                                                        "msg_header " +
                                                        (item.message
                                                            ? ""
                                                            : "msg_header_hide")
                                                    }
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            bannedWords(
                                                                item.message
                                                            ) || "",
                                                    }}
                                                ></div>
                                            ) : (
                                                ""
                                            )}
                                            <div
                                                className={
                                                    "msg-file-cont " +
                                                    (item.medias.length == 0
                                                        ? " "
                                                        : " msg-file-cont-has-file") +
                                                    (item.price > 0 &&
                                                    item.medias.length > 0 &&
                                                    item.sender_id !=
                                                        localStorage.getItem(
                                                            "loggedin_user"
                                                        ) &&
                                                    item.msg_type == 1 &&
                                                    !paidPpvs.includes(item.id)
                                                        ? " un-msg "
                                                        : " p-msg ") +
                                                    `${
                                                        item.message
                                                            ? "has-message"
                                                            : ""
                                                    }`
                                                }
                                            >
                                                {item.price > 0 &&
                                                item.medias.length > 0 &&
                                                item.sender_id !=
                                                    localStorage.getItem(
                                                        "loggedin_user"
                                                    ) &&
                                                item.msg_type == 1 &&
                                                !paidPpvs.includes(item.id) ? (
                                                    <div
                                                        className="ppv-unlock"
                                                        id={`ppv-unlock-main-${item.id}`}
                                                    >
                                                        <div
                                                            className="ppv-unlock-icon"
                                                            id={`ppv-unlock-icon-${item.id}`}
                                                        >
                                                            <img
                                                                src={ppvLock}
                                                            />
                                                        </div>
                                                        {parseInt(
                                                            item.medias[0]
                                                                .vid_duration
                                                        ) > 0 && (
                                                            <div className="video-lenght">
                                                                <i
                                                                    className="fa fa-play"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                {renderDuration(
                                                                    parseInt(
                                                                        item
                                                                            .medias[0]
                                                                            .vid_duration
                                                                    )
                                                                )}
                                                            </div>
                                                        )}
                                                        {confirmPay ==
                                                        item.id ? (
                                                            renderPaymentButton(
                                                                item,
                                                                processingPay,
                                                                isDiscounted
                                                            )
                                                        ) : (
                                                            <div
                                                                className="ppv-unlock-btn"
                                                                onClick={() =>
                                                                    handleUnlockMedia(
                                                                        item.sender_id,
                                                                        isDiscounted
                                                                            ? item.promo_price
                                                                            : item.price,
                                                                        item.id
                                                                    )
                                                                }
                                                            >
                                                                UNLOCK FOR&nbsp;
                                                                <PriceText
                                                                    price={
                                                                        item.price
                                                                    }
                                                                    discountedPrice={
                                                                        item.promo_price
                                                                    }
                                                                    isDiscounted={
                                                                        isDiscounted
                                                                    }
                                                                />
                                                            </div>
                                                        )}

                                                        {confirmPay ==
                                                        item.id ? (
                                                            ppvFees.fees &&
                                                            !!ppvFees.reg_gst &&
                                                            ppvFees.gst > 0 ? (
                                                                <div className="ppv-chrg-text mb-1">
                                                                    {currency(
                                                                        ppvFees.fees
                                                                    ).format({
                                                                        precision: 2,
                                                                    })}{" "}
                                                                    processing
                                                                    fee plus{" "}
                                                                    {currency(
                                                                        ppvFees.gst
                                                                    ).format()}{" "}
                                                                    GST will
                                                                    apply.{" "}
                                                                </div>
                                                            ) : (
                                                                <div className="ppv-chrg-text mb-1">
                                                                    {currency(
                                                                        ppvFees.fees
                                                                    ).format({
                                                                        precision: 2,
                                                                    })}{" "}
                                                                    processing
                                                                    fee will
                                                                    apply.
                                                                </div>
                                                            )
                                                        ) : (
                                                            <div className="ppv-chrg-text"></div>
                                                        )}

                                                        {isDiscounted ? (
                                                            <div className="promo_counter">
                                                                <span className="limited-offer-label">
                                                                    Limited
                                                                    offer
                                                                    expires in:
                                                                </span>
                                                                <br />
                                                                <CountDownTimer
                                                                    dateTime={
                                                                        message.expire_at
                                                                    }
                                                                    id={
                                                                        message.id
                                                                    }
                                                                    onEndTime={
                                                                        handleEndTime
                                                                    }
                                                                    isEmphasized={
                                                                        true
                                                                    }
                                                                    isUTC
                                                                />
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}

                                                        {item.medias.length >
                                                            1 && (
                                                            <div className="ppv-gall-stats">
                                                                {
                                                                    item.medias.filter(
                                                                        (
                                                                            smed
                                                                        ) =>
                                                                            smed.type &&
                                                                            smed.type.toLowerCase() ==
                                                                                "image"
                                                                    ).length
                                                                }
                                                                &nbsp;
                                                                <i className="fa-regular fa-image"></i>{" "}
                                                                &nbsp;&nbsp;{" "}
                                                                {
                                                                    item.medias.filter(
                                                                        (
                                                                            smed
                                                                        ) =>
                                                                            smed.type &&
                                                                            smed.type.toLowerCase() ==
                                                                                "video"
                                                                    ).length
                                                                }
                                                                &nbsp;
                                                                <i className="fa-solid fa-video"></i>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    ""
                                                )}

                                                {item.msg_type ==
                                                    MESSAGE_TYPE.STORY &&
                                                    item.medias.map(
                                                        (attach, index) => (
                                                            <div key={index}>
                                                                {attach.type &&
                                                                    attach.type.toLowerCase() ===
                                                                        "image" && (
                                                                        <span
                                                                            className="cust-fancybox cust-fancybox1 single-img-cont single-img-cont1"
                                                                            onClick={() =>
                                                                                openModalImage(
                                                                                    attach.large_path
                                                                                )
                                                                            }
                                                                        >
                                                                            <Media
                                                                                media={
                                                                                    attach
                                                                                }
                                                                                sender_id={
                                                                                    item.sender_id
                                                                                }
                                                                                msg_type={
                                                                                    item.msg_type
                                                                                }
                                                                                msg_id={
                                                                                    item.id
                                                                                }
                                                                                isStory={
                                                                                    !!item.story_id
                                                                                }
                                                                            />
                                                                        </span>
                                                                    )}
                                                                {attach.type &&
                                                                    attach.type.toLowerCase() ===
                                                                        "video" && (
                                                                        <Media
                                                                            media={
                                                                                attach
                                                                            }
                                                                            sender_id={
                                                                                item.sender_id
                                                                            }
                                                                            msg_type={
                                                                                item.msg_type
                                                                            }
                                                                            msg_id={
                                                                                item.id
                                                                            }
                                                                        />
                                                                    )}
                                                            </div>
                                                        )
                                                    )}
                                                {item.medias.length > 1 && (
                                                    <Carousel
                                                        {...settings}
                                                        prevIcon={<PrevIcon />}
                                                        nextIcon={<NextIcon />}
                                                        interval={null}
                                                        ref={carouselRef}
                                                    >
                                                        {item.medias.map(
                                                            (attach, index) =>
                                                                item.price >
                                                                    0 &&
                                                                item.sender_id !=
                                                                    localStorage.getItem(
                                                                        "loggedin_user"
                                                                    ) &&
                                                                !paidPpvs.includes(
                                                                    item.id
                                                                ) &&
                                                                item.msg_type !==
                                                                    2 ? (
                                                                    <Carousel.Item
                                                                        className="chat-bubble-items chat-bubble-items1"
                                                                        key={`chat-bubble-item-${index}`}
                                                                    >
                                                                        <div
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <span
                                                                                onClick={() =>
                                                                                    openModalBundle(
                                                                                        item.medias,
                                                                                        index
                                                                                    )
                                                                                }
                                                                            >
                                                                                {attach.type &&
                                                                                    attach.type.toLowerCase() ===
                                                                                        "image" && (
                                                                                        // <span onClick={() => openModalImage(attach)}>
                                                                                        <Media
                                                                                            media={
                                                                                                attach
                                                                                            }
                                                                                            sender_id={
                                                                                                item.sender_id
                                                                                            }
                                                                                            msg_type={
                                                                                                item.msg_type
                                                                                            }
                                                                                            msg_id={
                                                                                                item.id
                                                                                            }
                                                                                        />
                                                                                    )}
                                                                                {attach.type &&
                                                                                    attach.type.toLowerCase() ===
                                                                                        "video" && (
                                                                                        <Media
                                                                                            media={
                                                                                                attach
                                                                                            }
                                                                                            sender_id={
                                                                                                item.sender_id
                                                                                            }
                                                                                            msg_type={
                                                                                                item.msg_type
                                                                                            }
                                                                                            msg_id={
                                                                                                item.id
                                                                                            }
                                                                                        />
                                                                                    )}
                                                                            </span>

                                                                            {attach.free_preview && (
                                                                                <span className="su-free-preview__label">
                                                                                    Free
                                                                                    Preview
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </Carousel.Item>
                                                                ) : (
                                                                    <Carousel.Item
                                                                        className="chat-bubble-items chat-bubble-items2"
                                                                        key={`chat-bubble-item-${index}`}
                                                                    >
                                                                        <div
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            {attach.type &&
                                                                                attach.type.toLowerCase() ===
                                                                                    "image" && (
                                                                                    <span
                                                                                        className="cust-fancybox custom-fancyboxmany"
                                                                                        onClick={() =>
                                                                                            openModalBundle(
                                                                                                item.medias,
                                                                                                index
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <Media
                                                                                            media={
                                                                                                attach
                                                                                            }
                                                                                            sender_id={
                                                                                                item.sender_id
                                                                                            }
                                                                                            msg_type={
                                                                                                item.msg_type
                                                                                            }
                                                                                            msg_id={
                                                                                                item.id
                                                                                            }
                                                                                        />
                                                                                    </span>
                                                                                )}
                                                                            {attach.type &&
                                                                                attach.type.toLowerCase() ===
                                                                                    "video" && (
                                                                                    <div
                                                                                        className="vid_thumb_cont"
                                                                                        onClick={() =>
                                                                                            openModalBundle(
                                                                                                item.medias,
                                                                                                index
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        {user.id !==
                                                                                            attach.pu_id &&
                                                                                            attach.file_path !==
                                                                                                null && (
                                                                                                <div
                                                                                                    className={
                                                                                                        "message-item-thumbprint-preview-container"
                                                                                                    }
                                                                                                >
                                                                                                    <Thumbprint />
                                                                                                </div>
                                                                                            )}
                                                                                        <div
                                                                                            className={
                                                                                                "video-thumb-bundle"
                                                                                            }
                                                                                        >
                                                                                            <FontAwesomeIcon
                                                                                                icon={[
                                                                                                    "fas",
                                                                                                    "play-circle",
                                                                                                ]}
                                                                                            />
                                                                                            <img
                                                                                                src={`${s3Link}/${attach.thumb_path}`}
                                                                                                className="img-fluid"
                                                                                                alt="Your browser wasn't able to download the media file, please refresh browser or check your internet is not having dropouts."
                                                                                                threshold={
                                                                                                    1000
                                                                                                }
                                                                                                onContextMenu={(
                                                                                                    e
                                                                                                ) =>
                                                                                                    e.preventDefault()
                                                                                                }
                                                                                                nosave="true"
                                                                                            />
                                                                                            {(paidPpvs.find(
                                                                                                (
                                                                                                    element
                                                                                                ) =>
                                                                                                    element ==
                                                                                                    item.id
                                                                                            ) ||
                                                                                                item.msg_type !=
                                                                                                    1) && (
                                                                                                <Duration
                                                                                                    duration={
                                                                                                        attach.vid_duration
                                                                                                    }
                                                                                                />
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                            {attach.free_preview && (
                                                                                <span className="su-free-preview__label">
                                                                                    Free
                                                                                    Preview
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </Carousel.Item>
                                                                )
                                                        )}
                                                    </Carousel>
                                                )}

                                                {item.medias.length == 1 && (
                                                    <>
                                                        {item.medias.map(
                                                            (attach, index) =>
                                                                item.price >
                                                                    0 &&
                                                                item.sender_id !=
                                                                    localStorage.getItem(
                                                                        "loggedin_user"
                                                                    ) &&
                                                                item.msg_type ==
                                                                    1 ? (
                                                                    <div
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        {attach.type &&
                                                                            attach.type.toLowerCase() ===
                                                                                "image" && (
                                                                                <span
                                                                                    onClick={() =>
                                                                                        openModalImage(
                                                                                            attach
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <Media
                                                                                        media={
                                                                                            attach
                                                                                        }
                                                                                        sender_id={
                                                                                            item.sender_id
                                                                                        }
                                                                                        msg_type={
                                                                                            item.msg_type
                                                                                        }
                                                                                        msg_id={
                                                                                            item.id
                                                                                        }
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                        {attach.type &&
                                                                            attach.type.toLowerCase() ===
                                                                                "video" && (
                                                                                <Media
                                                                                    media={
                                                                                        attach
                                                                                    }
                                                                                    sender_id={
                                                                                        item.sender_id
                                                                                    }
                                                                                    msg_type={
                                                                                        item.msg_type
                                                                                    }
                                                                                    msg_id={
                                                                                        item.id
                                                                                    }
                                                                                />
                                                                            )}
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        {attach.type &&
                                                                            attach.type.toLowerCase() ===
                                                                                "image" && (
                                                                                <span
                                                                                    className={
                                                                                        "cust-fancybox cust-fancybox1 " +
                                                                                        (item.msg_type ==
                                                                                        0
                                                                                            ? "single-img-cont single-img-cont2"
                                                                                            : "")
                                                                                    }
                                                                                    onClick={() =>
                                                                                        openModalImage(
                                                                                            attach
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <Media
                                                                                        media={
                                                                                            attach
                                                                                        }
                                                                                        sender_id={
                                                                                            item.sender_id
                                                                                        }
                                                                                        msg_type={
                                                                                            item.msg_type
                                                                                        }
                                                                                        msg_id={
                                                                                            item.id
                                                                                        }
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                        {attach.type &&
                                                                            attach.type.toLowerCase() ===
                                                                                "video" && (
                                                                                <Media
                                                                                    media={
                                                                                        attach
                                                                                    }
                                                                                    sender_id={
                                                                                        item.sender_id
                                                                                    }
                                                                                    msg_type={
                                                                                        item.msg_type
                                                                                    }
                                                                                    msg_id={
                                                                                        item.id
                                                                                    }
                                                                                />
                                                                            )}
                                                                    </div>
                                                                )
                                                        )}
                                                    </>
                                                )}
                                                <div
                                                    className={
                                                        "msg-text-def " +
                                                        (item.message &&
                                                        item.medias.length == 0
                                                            ? "msg-text-cont "
                                                            : " ") +
                                                        (isMutedMessage
                                                            ? "msg-text-muted"
                                                            : " ")
                                                    }
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            (item.medias
                                                                .length == 0 &&
                                                                bannedWords(
                                                                    item.message
                                                                )) ||
                                                            "",
                                                    }}
                                                ></div>

                                                {
                                                    // Show spinner while image is still downloaded
                                                    item &&
                                                    item.hasOwnProperty(
                                                        "has_media"
                                                    ) &&
                                                    item.has_media ? (
                                                        <div className="d-flex justify-content-center p-2">
                                                            <Spinner
                                                                size="sm"
                                                                animation="border"
                                                                variant="primary"
                                                            />
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )
                                                }
                                            </div>

                                            {item.price > 0 &&
                                            item.medias.length > 0 &&
                                            item.msg_type == 1 &&
                                            item.sender_id ==
                                                localStorage.getItem(
                                                    "loggedin_user"
                                                ) ? (
                                                <div className="msg_footer">
                                                    Message for{" "}
                                                    <span>
                                                        <span className="red">
                                                            <PriceText
                                                                price={
                                                                    item.price
                                                                }
                                                                discountedPrice={
                                                                    item.promo_price
                                                                }
                                                                isDiscounted={
                                                                    isDiscounted
                                                                }
                                                            />
                                                        </span>{" "}
                                                        has not been paid to
                                                        view yet
                                                    </span>
                                                </div>
                                            ) : (
                                                ""
                                            )}

                                            {item.price > 0 &&
                                                item.medias.length > 0 &&
                                                item.msg_type == 1 &&
                                                item.sender_id ==
                                                    localStorage.getItem(
                                                        "loggedin_user"
                                                    ) &&
                                                isDiscounted &&
                                                isValidDate && (
                                                    <div className="promo_counter">
                                                        <span className="limited-offer-label">
                                                            Limited offer
                                                            expires in:
                                                        </span>
                                                        <br />
                                                        <CountDownTimer
                                                            dateTime={
                                                                message.expire_at
                                                            }
                                                            id={message.id}
                                                            onEndTime={
                                                                handleEndTime
                                                            }
                                                            isEmphasized={true}
                                                            isUTC
                                                        />
                                                    </div>
                                                )}

                                            {item.price > 0 &&
                                            item.medias.length > 0 &&
                                            item.msg_type == 2 &&
                                            item.sender_id ==
                                                localStorage.getItem(
                                                    "loggedin_user"
                                                ) ? (
                                                <div className="msg_footer">
                                                    Message has been viewed for{" "}
                                                    <span className="red">
                                                        {currency(
                                                            item.buy_price
                                                        ).format({
                                                            precision: 2,
                                                        })}
                                                    </span>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            {item.medias.length > 1 &&
                                                item.sender_id ==
                                                    localStorage.getItem(
                                                        "loggedin_user"
                                                    ) && (
                                                    <div className="ppv-gall-stats">
                                                        {
                                                            item.medias.filter(
                                                                (smed) =>
                                                                    smed.type &&
                                                                    smed.type.toLowerCase() ==
                                                                        "image"
                                                            ).length
                                                        }
                                                        &nbsp;
                                                        <i className="fa-regular fa-image"></i>{" "}
                                                        &nbsp;&nbsp;{" "}
                                                        {
                                                            item.medias.filter(
                                                                (smed) =>
                                                                    smed.type &&
                                                                    smed.type.toLowerCase() ==
                                                                        "video"
                                                            ).length
                                                        }
                                                        &nbsp;
                                                        <i className="fa-solid fa-video"></i>
                                                    </div>
                                                )}
                                        </div>
                                    ) : (
                                        ""
                                    )
                                    // end of no preview
                                }

                                {item.sender_id !=
                                    localStorage.getItem("loggedin_user") &&
                                    item.price > 0 &&
                                    item.medias &&
                                    item.medias.length > 1 &&
                                    item.has_free_preview &&
                                    item.msg_type == MESSAGE_TYPE.UNPURCHASED &&
                                    !paidPpvs.includes(item.id) && (
                                        <div className="su-free-preview">
                                            {item.message.length > 0 && (
                                                <div className="su-free-preview__message">
                                                    {item.message}
                                                </div>
                                            )}

                                            <div
                                                className="su-free-preview__media"
                                                onClick={() =>
                                                    openFreePreview(
                                                        item.medias[0]
                                                    )
                                                }
                                            >
                                                {
                                                    <>
                                                        {userDetails.id !==
                                                            item.sender_id && (
                                                            <div
                                                                className={
                                                                    "message-item-thumbprint-free-preview-container"
                                                                }
                                                            >
                                                                <Thumbprint />
                                                            </div>
                                                        )}
                                                        <img
                                                            src={`${s3Link}/${item.medias[0].thumb_path}`}
                                                        />
                                                    </>
                                                }
                                                {item.medias[0].type.toLowerCase() ===
                                                    "video" && (
                                                    <span className="su-free-preview__media-video">
                                                        <i className="fa-solid fa-circle-play"></i>
                                                    </span>
                                                )}

                                                <span className="su-free-preview__label">
                                                    Free Preview
                                                </span>
                                            </div>

                                            <div className="su-free-preview__stats">
                                                <div className="mb-2">
                                                    {item.medias.length > 1 && (
                                                        <div className="gallery">
                                                            {
                                                                item.medias.filter(
                                                                    (smed) =>
                                                                        smed.type &&
                                                                        smed.type.toLowerCase() ==
                                                                            "image"
                                                                ).length
                                                            }
                                                            &nbsp;
                                                            <i className="fa-regular fa-image"></i>{" "}
                                                            &nbsp;&nbsp;
                                                            {
                                                                item.medias.filter(
                                                                    (smed) =>
                                                                        smed.type &&
                                                                        smed.type.toLowerCase() ==
                                                                            "video"
                                                                ).length
                                                            }
                                                            &nbsp;
                                                            <i className="fa-solid fa-video"></i>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="mb-2">
                                                    {confirmPay == item.id ? (
                                                        renderPaymentButton(
                                                            item,
                                                            processingPay,
                                                            isDiscounted
                                                        )
                                                    ) : (
                                                        <div
                                                            className="ppv-unlock-btn"
                                                            onClick={() =>
                                                                handleUnlockMedia(
                                                                    item.sender_id,
                                                                    isDiscounted
                                                                        ? item.promo_price
                                                                        : item.price,
                                                                    item.id
                                                                )
                                                            }
                                                        >
                                                            UNLOCK FOR&nbsp;
                                                            <PriceText
                                                                price={
                                                                    item.price
                                                                }
                                                                discountedPrice={
                                                                    item.promo_price
                                                                }
                                                                isDiscounted={
                                                                    isDiscounted
                                                                }
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                {confirmPay == item.id ? (
                                                    ppvFees.fees &&
                                                    !!ppvFees.reg_gst &&
                                                    ppvFees.gst > 0 ? (
                                                        <div className="ppv-chrg-text mb-1">
                                                            {currency(
                                                                ppvFees.fees
                                                            ).format()}{" "}
                                                            processing fee plus{" "}
                                                            {currency(
                                                                ppvFees.gst
                                                            ).format()}{" "}
                                                            GST will apply.{" "}
                                                        </div>
                                                    ) : (
                                                        <div className="ppv-chrg-text mb-1">
                                                            {currency(
                                                                ppvFees.fees
                                                            ).format()}{" "}
                                                            processing fee will
                                                            apply.
                                                        </div>
                                                    )
                                                ) : (
                                                    <div className="ppv-chrg-text"></div>
                                                )}
                                                {isDiscounted && isValidDate ? (
                                                    <div className="promo_counter">
                                                        <span className="limited-offer-label">
                                                            Limited offer
                                                            expires in:
                                                        </span>
                                                        <br />
                                                        <CountDownTimer
                                                            dateTime={
                                                                message.expire_at
                                                            }
                                                            id={message.id}
                                                            onEndTime={
                                                                handleEndTime
                                                            }
                                                            isEmphasized={true}
                                                            isUTC
                                                        />
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </div>
                                    )}

                                {!item.medias && (
                                    <div className={`user-cmnt msg-text-only`}>
                                        <div className="msg-text-def msg-text-cont">
                                            {bannedWords(item.message)}
                                        </div>
                                    </div>
                                )}

                                {(item.status == 1 &&
                                    item.sender_id ==
                                        localStorage.getItem(
                                            "loggedin_user"
                                        )) ||
                                readCollection.includes(item.id) ? (
                                    <div className="tickimage">
                                        <img src={DoubleCheck} />
                                    </div>
                                ) : (
                                    ""
                                )}

                                {item.status == 0 &&
                                item.sender_id ==
                                    localStorage.getItem("loggedin_user") &&
                                !readCollection.includes(item.id) ? (
                                    <div className="tickimage">
                                        <img src={SingleCheck} />
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <PAlert
                    show={showAlert}
                    setShow={setShowAlert}
                    title={alertTitle}
                    body={alertBody}
                />

                <Dialog
                    open={showConfirm}
                    onClose={() => setShowConfirm(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {confirmModalBody}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {!isRemoving && (
                            <Button
                                disabled={isRemoving}
                                onClick={() => setShowConfirm(false)}
                            >
                                Cancel
                            </Button>
                        )}
                        <Button
                            onClick={removeMessage}
                            disabled={isRemoving}
                            autoFocus
                        >
                            {isRemoving ? (
                                <>
                                    <CircularProgress size={10} />
                                    &nbsp;Removing...
                                </>
                            ) : (
                                "Yes, remove"
                            )}
                        </Button>
                    </DialogActions>
                </Dialog>

                {showPaymentOptions ? (
                    <PaymentOptions
                        show={showPaymentOptions}
                        setShow={setShowPaymentOptions}
                        // onClickPayNow={() => payPPV(item.price, item)}
                        onClickPayNow={() =>
                            ppvProcessPayment(
                                isDiscounted ? item.promo_price : item.price,
                                item.id
                            )
                        }
                        amount={isDiscounted ? item.promo_price : item.price}
                        action={TRANSACTION_TYPE.PPV}
                        pu={item}
                        onSuccess={handleOnSuccessPayment}
                        item={item}
                        isBusy={isGettingMessage}
                    />
                ) : null}
            </div>
        );
    }
);

function mapStateToProps(state) {
    return {
        msgOptionOpen: state.message.msgOptionOpen,
        convIndex: state.message.convIndex,
        convList: state.message.convList,
        triggerScrollBottom: state.message.triggerScrollBottom,
        readCollection: state.message.read,
        user: state.user.user,
        msgStats: state.message.msgStats,
        mutedByOther: state.message.mute_other_val,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateTriggerScrollBottom: (triggerScrollBottom) =>
            dispatch(updateTriggerScrollBottomR(triggerScrollBottom)),
        updateMsgOptionOpen: (msgOptionOpen) =>
            dispatch(updateMsgOptionOpenR(msgOptionOpen)),
        updateMsgStats: (msgStats) => dispatch(updateMsgStatsR(msgStats)),
        setConvIndex: (convIndex) => dispatch(setConvIndexR(convIndex)),
        reorderReceiveConvList: (convList, convIndex, newMsg, newTime) =>
            dispatch(
                reorderReceiveConvListR(convList, convIndex, newMsg, newTime)
            ),
        updateShowImageModal: (showImageModal) =>
            dispatch(updateShowImageModalR(showImageModal)),
        updateImageModalSrc: (imageModalSrc) =>
            dispatch(updateImageModalSrcR(imageModalSrc)),
        updateShowBundleModal: (showBundleModal) =>
            dispatch(updateShowBundleModalR(showBundleModal)),
        updateBundleModalSrc: (bundleModalSrc) =>
            dispatch(updateBundleModalSrcR(bundleModalSrc)),
        updateBundleIndex: (bundleIndex) =>
            dispatch(updateBundleIndexR(bundleIndex)),
        updateshowVideoModal: (showVideoModal) =>
            dispatch(updateshowVideoModalR(showVideoModal)),
        updateShowVerification: (showVerification) =>
            dispatch(updateShowVerificationR(showVerification)),
        setContainerClass: (medias) => dispatch(setContainerClass(medias)),
        updateCcVerification: (payload) =>
            dispatch(updateCcVerification(payload)),
        setAlert: (payload) => dispatch(setAlert(payload)),
        setCreditCardForm: (payload) => dispatch(setCreditCardForm(payload)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(MessageItem);
